import {
  CC_MODERATION_USER_JOINED,
  CC_STATUS_CHANGED,
  CC_MODERATION_USER_LEFT
} from "./types/ccModeration";

export const ccModerationUserJoined = (payload) => ({
  type: CC_MODERATION_USER_JOINED,
  payload,
});

export const ccModerationUserLeft = (payload) => ({
  type: CC_MODERATION_USER_LEFT,
  payload,
});

export const ccStatusChanged = (payload) => ({
  type: CC_STATUS_CHANGED,
  payload,
});
